import React from "react";
import PropTypes from "prop-types";
import { classNames } from "../../../utils/helpers";

const STATUS_STYLES = {
  success: {
    container: "bg-green-100",
    dot: "bg-green-700",
    text: "text-green-700",
  },
  warning: {
    container: "bg-yellow-100",
    dot: "bg-yellow-700",
    text: "text-yellow-700",
  },
  neutral: {
    container: "bg-gray-100",
    dot: "bg-gray-700",
    text: "text-gray-700",
  },
  danger: {
    container: "bg-red-100",
    dot: "bg-red-700",
    text: "text-red-700",
  },
  info: {
    container: "bg-blue-100",
    dot: "bg-blue-700",
    text: "text-blue-700",
  },
  bound: {
    container: "bg-purple-100",
    dot: "bg-purple-700",
    text: "text-purple-700",
  },
};

const StatusChip = ({ label, variant = "neutral", className }) => {
  const styles = STATUS_STYLES[variant] || STATUS_STYLES.neutral;

  return (
    <div
      className={classNames(
        "rounded-lg px-3 py-1 flex items-center gap-2 font-semibold text-sm overflow-hidden",
        styles.container,
        className,
      )}
    >
      <div
        className={classNames("w-2 h-2 rounded-full flex-shrink-0", styles.dot)}
      />
      <span className={classNames("text-[12px] truncate min-w-0", styles.text)}>
        {label}
      </span>
    </div>
  );
};

StatusChip.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["success", "warning", "neutral", "danger", "info"]),
  className: PropTypes.string,
};

export default StatusChip;
